"use strict";
/// <reference path="irep.js"/>

/* This script is for v1 of the tools page. It exists only in ASMO at the moment. Please check ToolsUpdate.js for the current version of the tools script. */ 

IREP.tools = (function () {

    var currentCarouselItem = 0;
    var isInitializing = true;
    var defaultSearchValue;

    var minResToShowHighlightedItem = 400; //If height of the page is less than this value, do not show the highlighted item. 
    var highlightedItemHidden = false; //Holds if the slider drawer is pulled out or not

    var pageStartIndex = 1; // The item id that starts the current page we are on. When we page, add/subtract the searchDisplayCount to get new start point. 
    var pageCounter = 1; //starting page index for the isotope pager
    var searchDisplayCount = 8; //Number of items per page for the isotope pager
    var currentFileFilter = "ALL"; //Holds the currently selected file-type button filter
    var currentType = "0"; //Holds the currently selected tool-type filter.
    var currentMaterials = "0"; //Holds the currently selected materials.
    var cultureCode = 'en-GB'; //The current participants' culture code
    var currentTools = ''; //The ID of the currently magnified tool 
    var bottomDrawer = null;
    var bottomDrawerLoading = false;

    var downloadBtnText = '';
    var watchBtnText = '';

    var init = function (toolsOptions) {
        $("#dvTxtSearchPager").hide();

        initFilterControl(); //Configure the filter control functionality
        $("#footer").css("z-index", "3"); //Isotopes have a z-index of 3, so they render over top of the footer. This corrects that rendering issue. 

        $(".btn-group-link").on("click", function () {
            displayDetails($("#dvRepeaterItem_" + $(this).attr("data-linkitem")), $(this).attr("data-linkitem"));
            carouselSelection($(this));
        });

        var firstCtrl = $("#dvCarouselRepeaterData .dvRepeaterItemHidden:first");
        displayDetails(firstCtrl, firstCtrl.attr("data-linkitem"));
        carouselSelection($(".btn-group-link[data-indexitem=0]"));

        startTimer();

        cultureCode = toolsOptions.CultureCode; //Set culture code from passed in options  
        downloadBtnText = toolsOptions.DownloadBtnText; //Set culture code from passed in options       
        watchBtnText = toolsOptions.WatchBtnText; //Set culture code from passed in options       

        //Filters the isotopes based on the selected text. 
        $('#btnSearchTools').on("click", function () {
            updateDisplay(currentFileFilter, currentType, currentMaterials);
            return false;
        });

        $(".downloadToolLink").on("click", function () {
            var toolId = $(this).attr('data-toolId');
            var fileName = $(this).attr('data-fileName');
            var uid = $(this).attr('data-uid');
            downloadAction(toolId, fileName, uid)

            return false;
        });

        // Enter keypress should trigger the loadresults
        $(document).keypress(function (e) {
            if (e.which === 13) {
                updateDisplay(currentFileFilter, currentType, currentMaterials);
                return false;
            }
        });

        if ($(window).height() < minResToShowHighlightedItem) {
            displayFilterResults(); //Do not show the enlarged item on this page. Not enough space for it to render properly.
        }

        //Whenever I initialize this isotope, it sets position relative, which causes the isotope container to vanish. 
        //I'm setting it back to absolute. 

        //File Type Filter Button Events:
        $("#btnChgViewAll").click(function () { changeView('ALL'); return false; });
        $("#btnChgViewVideo").click(function () { changeView('Video'); return false; });
        $("#btnChgViewPdf").click(function () { changeView('PDF'); return false; });
        $("#btnChgViewOther").click(function () { changeView('Other'); return false; });

        //Handle click of details.
        $(".toolDisplayDetails").on("click", function () {
            showTools($(this).attr('data-toolId'), '', $(this).attr('data-uid'), false);
            return false;
        });

        $(".toolDisplayDetails").on("click", ".download", function () {
            window.open(this.href);
            return false;
        });

        //Set up the pager buttons to be prev & next buttons with arrows and IDs. 
        initPager();

        //Bind IDs 
        $("#btnPrevPage").click(function () { decrementPageCounter(); return false; });
        $("#btnNextPage").click(function () { incrementPageCounter(); return false; });


        //Transform dropdown style
        $("[ID*=ddlFilterValues]").change(function () {
            updateVisibility($(this).val());
            updateDdlStyle($(this));
        });
        $("[ID*=ddlQuestion2]").change(function () {
            updateMaterials($(this).val());
            updateDdlStyle($(this));
        });

        manageContentSize();
        isInitializing = false;
    };

    /*
    * Init and start the flash video player. 
    */
    var initPlayer = function (fileName, uid) {
        var params = {}; var attributes = {}; var flashvars = {};
        flashvars.CultureCode = IREP.options.user.cultureCode;
        flashvars.PostBackURL = "/ww/Pages/FlashDX/PostStatsUrl.aspx";
        flashvars.VideoURL = fileName;
        flashvars.VideoUID = uid;
        flashvars.ImageURL = '';
        flashvars.ParticipantUID = IREP.options.user.currentUID;
        flashvars.ShowStartButton = '1';
        flashvars.VideoSource = '0';
        flashvars.AutoPlayVideo = '1';
        swfobject.embedSWF('https://retailedge.intel.com/ww/swf/mt40player.swf', 'vidContainer', '640', '360', '9.0.0', '', flashvars, params, attributes);
    };

    /*
    * Call this to display the drawer if not already visible, and download / show video. 
    * Logs to DB. 
    */
    var downloadAction = function (toolId, fileName, uid) {
        postToolLog(toolId);

        if (fileName.match(/flv$/) != null) {
            showTools(toolId, fileName, uid, true);
        }
        else {
            window.open(fileName);
        }
    }

    /*
   * Initialize the filter control values and hint text display.
   */
    var initFilterControl = function () {
        var filterCtrl = $("[ID*=txtSearchVal]");
        if (filterCtrl !== undefined && filterCtrl !== null) {
            defaultSearchValue = filterCtrl.attr("defaultText");

            // swap the deafult Search box text on blur and focus
            if (filterCtrl.val() === "") filterCtrl.val(defaultSearchValue);

            filterCtrl.focus(function () {
                if ($(this).val() === defaultSearchValue) {
                    $(this).val("");
                }
            })
             .blur(function () {
                 if ($(this).val() === "") {
                     $(this).val(defaultSearchValue);
                 }
             });
        }
    };


    /*
    * Update the isotope layout filter. 
    */
    var isotopeFilterCmd = function (filterVal) {
        if ($("#dvCarouselContainer").is(':visible') && !isInitializing) {
            $("#dvCarouselContainer").fadeOut();
            $("#toolsIsotopeContainer").fadeIn();

            $("#dvTxtSearchPager").show();
        }
        isotopeRemovePadding();

        //Calls the INITIAL filtering command on isotope. 
        $('#toolsIsotopeContainer').isotope({
            resizable: false,
            filter: filterVal,
            itemSelector: '.tools'
        });

        isotopeAddPadding();
    };

    /*
    * Before calling isotope's filtering, remove all padding from isotopes. Re-add it after positioning. 
    */
    var isotopeRemovePadding = function () {
        $(".isotope-item").each(function () {
            $(this).css('margin-left', '0px'); // Remove padding for repositioned items
        });
    };

    /*
    * add padding to isotopes after positioning, to create nice spacing for each item.
    */
    var isotopeAddPadding = function () {
        //If the isotope item displayed is not at 0, set up the proper amount of padding. If you set the padding
        //on the element itself, then you get it on the 0 position ones, we only want to hit the left aligned ones. 
        $(".isotope-item").each(function () {
            if ($(this).position().left === 700)
                $(this).css('margin-left', '85px'); //< 90 because of the button that sticks out. 
            else
                $(this).css('margin-left', '0px'); // Remove padding for repositioned items
        });
    };

    var displayDetails = function (firstCtrl, toolId) {
        var title = firstCtrl.find('#dvHdnTitle').text();
        var details = firstCtrl.find('#dvHdnDescription').text();
        var imgUrl = firstCtrl.find('#dvLargeImgUrl').text();
        var dlLinkUrl = firstCtrl.find('#dvHdnLinkUrl').text();
        var btnTextUrl = firstCtrl.find('#dvHdnDlBtnText').text();

        $("#dvTextTitle").text(title);
        $("#dvTextDesc").text(details);
        $("#framedImg").attr("src", imgUrl);
        $("#btnDownload").attr('data-toolId', toolId);
        $("#dvTextTitle").attr('data-toolId', toolId);
        $("#dvTextDesc").attr('data-toolId', toolId);
    };

    var carouselSelection = function (newSelection) {
        $(".btn-group-selected").attr('class', 'btn-group-link'); //Remove old selection.
        newSelection.attr('class', 'btn-group-selected');
    };

    var startTimer = function () {
        setTimeout(showNext, 15000);
    };

    var showNext = function () {
        currentCarouselItem++;

        var ctrl = $(".btn-group-link[data-indexitem=" + currentCarouselItem + "]");
        if (ctrl.length === 0) {
            currentCarouselItem = 0;
            ctrl = $(".btn-group-link[data-indexitem=" + currentCarouselItem + "]");
        }

        var itemId = ctrl.attr("data-linkitem");

        var newCtrl = $("#dvRepeaterItem_" + itemId);
        displayDetails(newCtrl, itemId);
        carouselSelection(ctrl);

        setTimeout(showNext, 15000);
    };

    var manageIsotopeDisplayWidth = function (inclOtherItems) {
        if ($(window).width() >= 1500) {
            //If the screen is large, we change all our isotopes to 'small' and fit them in two columns
            $(".isotopeRepeaterItem").width('700px');
            $("#dvSearchDetails").width('1500px');


            if (inclOtherItems) {
                $("#dvTxtSearchValAsmo").width('500px');
                $(".txtSearchValAsmo").width('500px');


                $("#content").width('1500px');
                $("#toolsSearchButtons").width('1500px');
                $("#divCatQuestion").width('500px');
                $("#divMatsQuestion").width('500px');
                $("#divCategory").width('350px');
                $("#divMaterial").width('350px');
                $(".dvHideOverlapMaterial").width('335px');
            }
        }
        else if ($(window).width() >= 1150) {
            //If the screen is small, we change all our isotopes to 'large' and fit them in two columns
            $(".isotopeRepeaterItem").width('1135px');
            $("#dvSearchDetails").width('1150px');

            if (inclOtherItems) {
                $("#content").width('1150px');
                $("#toolsSearchButtons").width('1150px');
                $("#divCatQuestion").width('310px');
                $("#divMatsQuestion").width('310px');
                $("#divCategory").width('250px');
                $("#divMaterial").width('250px');
                $(".dvHideOverlapMaterial").width('235px');
                $("#ddlFilterValues").css({ 'width': 185 });
                $("#ddlQuestion2").css({ 'width': 185 });

                $("#dvTxtSearchValAsmo").width('500px');
                $(".txtSearchValAsmo").width('500px');

            }
        }
        else {
            var workingWidth = $(window).width();
            if (workingWidth < 800) workingWidth = 800;
            $(".isotopeRepeaterItem").width('700px');

            if (inclOtherItems) {
                $("#content").width(workingWidth);
                $("#toolsSearchButtons").width(workingWidth);
                $("#divCatQuestion").width(workingWidth / 4);
                $("#divMatsQuestion").width(workingWidth / 4);
                $("#divCategory").width(workingWidth / 4);
                $("#divMaterial").width(workingWidth / 4);
                $("#dvTxtSearchValAsmo").width('300px');
                $(".txtSearchValAsmo").width('300px');
            }
        }
    };

    /*
    * When we first load or the page is resized, this is called to control our visible content area. 
    */
    var manageContentSize = function () {
        manageIsotopeDisplayWidth(!isInitializing);

        var displaySize = $(window).height() - ($('#navbar').outerHeight(true) + $('#footer').outerHeight(true) + $('#pageHeaderContainer').outerHeight(true)) - 50;
        var minSize = $("#toolsHeaderContent").outerHeight(true) + $("#dvCarouselItem").outerHeight(true) + $("#dvToolsCarouselFooterText").outerHeight(true) + 50;

        if (!isInitializing) {
            displaySize = $('#toolsHeaderContent').outerHeight(true) + (($(".isotopeRepeaterItem").outerHeight(true) + 10) * 6);
        }

        if (minSize > displaySize) {
            $("#dvToolsMainBackground").height(minSize);
        }
        else {
            $("#dvToolsMainBackground").height(displaySize);
        }

        $("#pageContent").height($("#dvToolsMainBackground").height());
        $("#content").height($("#pageContent").height() + $("#pageHeaderContainer").height());
        $("#dvSearchDetails").height($("#dvToolsMainBackground").height() - $("#tblCategorySelect").outerHeight(true) - $("#footer").outerHeight(true));
        determineDisplayCount();
    };

    /*
    * Find out how many items we can display. 
    */
    var determineDisplayCount = function () {
        //Determine how many isotopes we can display on the page. 
        var horizontalItems = Math.floor($("#dvToolsMainBackground").width() / ($(".isotopeRepeaterItem").width()));
        if (horizontalItems < 1) horizontalItems = 1;
        var verticalItems = Math.floor($("#dvSearchDetails").height() / $(".isotopeRepeaterItem").outerHeight(true));
        var oldDisplayCount = searchDisplayCount;

        if (highlightedItemHidden === true) {
            searchDisplayCount = horizontalItems * verticalItems;
        }
        else {
            //The # of items that can be displayed on the front = the same as the search page, less one column due to the magnified item. 
            searchDisplayCount = (horizontalItems - 1) * verticalItems;
        }

        //If our # of displayed items changes, then we re-query what will be displayed. 
        if (oldDisplayCount !== searchDisplayCount) {
            showItems(currentFileFilter, currentType, currentMaterials);
        }
    };



    /*
    * Handle animation for the main 'search all tools' drawer
    */
    var hideFilterResults = function () {
        if (highlightedItemHidden === true) {
            highlightedItemHidden = false;
            manageContentSize();
        }

        return false;
    };

    /*
    * Handle animation for fading back out to the front page. 
    */
    var displayFilterResults = function () {
        if (highlightedItemHidden === false) {

            highlightedItemHidden = true;
            manageContentSize();
        }
        return false;
    };


    /*
    * Show/hide the loading icon
    */
    var showLoader = function (show) {
        if (show === 1) {
            $('#toolsImgLoader').fadeTo(0, 1);
        } else {
            $('#toolsImgLoader').fadeTo(800, 0);
        }
    };


    /*
    * initialize the pager control, with the number of pages that we need to display. 
    */
    var initPager = function () {
        $("#dvTxtSearchPager .pager a").each(function () {
            if ($(this).children("span").html() === "&lt;") {
                $(this).attr("id", "btnPrevPage");
            }
            else if ($(this).children("span").html() === "&gt;") {
                $(this).attr("id", "btnNextPage");

            }
        });

        $("#dvTxtSearchPagerAsmo .pager a").each(function () {
            if ($(this).children("span").html() === "&lt;") {
                $(this).attr("id", "btnPrevPage");
            }
            else if ($(this).children("span").html() === "&gt;") {
                $(this).attr("id", "btnNextPage");

            }
        });

        manageBtnVisibility();
    };

    /*
    * Whenever the page changes, manage the next and previous button highlights. 
    */
    var manageBtnVisibility = function () {
        if (pageCounter != 1)
            $("#btnPrevPage").children().first("span").addClass("prev");
        else
            $("#btnPrevPage").children().first("span").removeClass("prev");

        /* PageStartIndex is the index of the first item on the page, but is one based. So we subtract one from the 
           search display count so that when there is one item left to show, it gets displayed */
        if (pageStartIndex + (searchDisplayCount - 1) < $(".isotopeRepeaterItem").length) 
            $("#btnNextPage").children().first("span").addClass("next");
        else
            $("#btnNextPage").children().first("span").removeClass("next");
    }

    /*
    * When page-prev is clicked
    */
    var decrementPageCounter = function () {
        if (pageCounter > 1) {
            pageCounter--;
            pageStartIndex -= searchDisplayCount;
            if (pageStartIndex < 1) { pageStartIndex = 1; }
            updateDisplay(currentFileFilter, currentType, currentMaterials);
        }
    };

    /*
    * When page-next is clicked
    */
    var incrementPageCounter = function () {
        if ($(".isotopeRepeaterItem").length > pageStartIndex + (searchDisplayCount - 1)) {
            pageCounter++;
            pageStartIndex += searchDisplayCount;
            updateDisplay(currentFileFilter, currentType, currentMaterials);
        }
    };

    /*
    * Set the page counter to the new value. 
    */
    var changePageCounter = function (newValue) {
        while (pageCounter !== newValue) {
            if (pageCounter > newValue) {
                decrementPageCounter();
            }
            else {
                incrementPageCounter();
            }
        }
    };

    /*
    * Loads the tool drawer and then display the drawer details 
    */
    var showTools = function (toolsId, fileName, uid, autoPlayVideo) {
        if (bottomDrawer === null && bottomDrawerLoading === false) {
            bottomDrawerLoading = true;

            if ($("#overlay").length === 0) {
                $("#content").append($("<div id='overlay' />").addClass("overlay"));

                $("#overlay").click(function () {
                    $("a[type='reset']").click(); /* Close modal */
                });
            }
            else {
                $("#overlay").show();
            }
            $.get(IREP.options.appUrl + IREP.options.user.site.toLowerCase() + "/tools/Controls/ToolsMagnifier.ajax", {}, function (html) {

                bottomDrawer = IREP.bottomdrawer.init({
                    container: $("<div id=\"toolDrawerContainer\">").addClass("toolDrawerContainer").append(html).appendTo("body"),
                    drawerId: "toolDrawerContainer"
                });
            }).done(function () {
                bottomDrawerLoading = false;
                displayToolData(toolsId);

                //Initialize log 
                $("#btnIsotopeMagnifierDownload").click(function () {
                    var toolId = $(this).attr('data-toolId');
                    var fileName = $(this).attr('data-fileName');
                    var uid = $(this).attr('data-uid');
                    downloadAction(toolId, fileName, uid);
                });

                if (autoPlayVideo) {
                    $("#vidPlayerContainer").show();
                    $("#imgToolContainer").hide();
                    $(".dvToolsMagnifierPositionImg").width('650px');
                    $(".dvToolsMagnifierPositionImg").height('350px');
                    initPlayer(fileName, uid);
                }
                else {
                    $("#vidPlayerContainer").hide();
                    $("#imgToolContainer").show();
                    $(".dvToolsMagnifierPositionImg").width('400px');
                    $(".dvToolsMagnifierPositionImg").height('350px');
                }
            });
        }
        else if (bottomDrawer != null) {

            if ($("#overlay").length === 0) {
                $("#content").append($("<div id='overlay' />").addClass("overlay"));

                $("#overlay").click(function () {
                    $("a[type='reset']").click(); /* Close modal */
                });
            }
            else {
                $("#overlay").show();
            }

            bottomDrawer.show();
            if (autoPlayVideo) {
                $("#vidPlayerContainer").show();
                $("#imgToolContainer").hide();
                $(".dvToolsMagnifierPositionImg").width('650px');
                $(".dvToolsMagnifierPositionImg").height('350px');
                initPlayer(fileName, uid);
                displayToolData(toolsId);
            }
            else {
                $("#vidPlayerContainer").hide();
                $("#imgToolContainer").show();
                $(".dvToolsMagnifierPositionImg").width('400px');
                $(".dvToolsMagnifierPositionImg").height('350px');
                displayToolData(toolsId);
            }
        }
        return false;
    };

    /*
    * Initialize db call to get tool information. 
    */
    var displayToolData = function (toolsId) {
        showLoader(1);

        var toolsParams = { toolId: toolsId, cultureCode: cultureCode };
        getToolsDetails(toolsParams);

        currentTools = toolsId;
    };

    /*
    * Log download of tool to DB for reporting. 
    */
    var postToolLog = function (toolId) {
        var params = { toolId: toolId };
        IREP.callApi("tools/logDownload", "POST", params);
    };

    /*
    * Retrieve the slider details from the JSON methods. 
    */
    var getToolsDetails = function (params) {
        IREP.callApi("tools/toolDetails", "GET", params)
            .done(function (data) {
                displayToolsInfo(data);
            });
    };

    /* 
    * Display the tools functional data in the slider2 container. 
    */
    var displayToolsInfo = function (data) {
        $("#divToolMagnifierCreatedDate").html(moment(data.data.publishDate).format('L')); //LL is the locale string format. 

        $("#divToolMagnifierTitle").html(data.data.name);
        $("#divToolMagnifierSubtitle").html(data.data.toolType);
        $("#divToolMagnifierDesc").html(data.data.description);
        $("#imgToolMagnifierTools").attr('src', data.data.thumbnail);
        $("#btnIsotopeMagnifierDownload").attr('data-toolId', data.data.id);
        $("#btnIsotopeMagnifierDownload").attr('data-fileName', data.data.url);
        $("#btnIsotopeMagnifierDownload").addClass('downloadToolLink');
        if (data.data.url.match(/flv$/)) {
            $("#btnIsotopeMagnifierDownload").html(watchBtnText);
        }
        else {
            $("#btnIsotopeMagnifierDownload").html(downloadBtnText);
        }

        showLoader(0);
    };

    /*
    * When the dropdown list changes, set the value of the current filter global variable, 
    * then change the view.
    */
    var updateVisibility = function (val) {
        currentType = val;
    };
    var updateMaterials = function (val) {
        currentMaterials = val;
    };

    var updateDdlStyle = function (ctrl) {
        if (ctrl.val() === "0") {
            ctrl.parent().addClass('divSelectUnanswered');
            ctrl.parent().removeClass('divSelectAnswered');
        }
        else {
            ctrl.parent().removeClass('divSelectUnanswered');
            ctrl.parent().addClass('divSelectAnswered');
        }
    };


    /*
    * Changeview - when a button or a dropdown is changed, this is called. The isotope container then autofilters its elements
    * based on the currently selected items.        
    */
    var changeView = function (view) {
        //Manage filter button coloring. 
        changePageCounter(1);
        if (view === "ALL") {
            $("#viewAll").attr('class', 'btnFilterActive');
            $("#viewAllAsmo").attr('class', 'btnFilterActive');
        }
        else {
            $("#viewAll").attr('class', 'btnFilter');
            $("#viewAllAsmo").attr('class', 'btnFilter');
        }
        if (view === "Other") {
            $("#viewOther").attr('class', 'btnFilterActive');
        }
        else {
            $("#viewOther").attr('class', 'btnFilter');
        }
        if (view === "PDF") {
            $("#viewPDFs").attr('class', 'btnFilterActive');
            $("#viewPrintAsmo").attr('class', 'btnFilterActive');
        } else {
            $("#viewPDFs").attr('class', 'btnFilter');
            $("#viewPrintAsmo").attr('class', 'btnFilter');
        }
        if (view === "Video") {
            $("#viewVideos").attr('class', 'btnFilterActive');
            $("#viewVideosAsmo").attr('class', 'btnFilterActive');
        } else {
            $("#viewVideos").attr('class', 'btnFilter');
            $("#viewVideosAsmo").attr('class', 'btnFilter');
        }

        currentFileFilter = view; //Set this for future reference external to this function.
        manageContentSize();
        $('#btnSearchTools').click(); //Fire off the search.
        return false; //Prevent page from bouncing back to the top. 
    };

    /*
    * Call whenever you need to update the visual display. This takes care of looking up the proper ten to display, 
    * and will handle the fun of hiding & displaying the current page we are on. 
    */
    var updateDisplay = function (fileFilter, typeFilter, materialFilter) {
        if (highlightedItemHidden === false)
            displayFilterResults();
        else
            showItems(fileFilter, typeFilter, materialFilter);

        manageBtnVisibility();
    };

    var showItems = function (fileFilter, typeFilter, materialFilter) {
        //This is the isotope filter value. Gets the ten items to display based on selected filters and current page index.
        var filterVal = manageRepeaterItemVisibility(fileFilter, typeFilter, materialFilter);

        // Check if no filter was returned. If nothing returned, show nothing. 
        if (filterVal === "") {
            filterVal = ".hideAllValuesCauseNothingMatchesThisFilter"; //Random long classmatch string. 
        }
        //Calls the filtering command on isotope. 
        isotopeFilterCmd(filterVal);
    };

    /*
    * The test was starting to get a little long inside the manageRepeaterItemVisibility function, so we moved it out to here. 
    * We're checking that the class matches the tag (or tag = 0) and the type to match the type of the object. 
    */
    var isMatch = function (obj, type, tag, material) {
        return objContainsText(obj) && ((tag === "0" || $(obj).attr('class').indexOf(tag) !== -1) &&
                (material === "0" || $(obj).attr('class').indexOf(material) !== -1) &&
                (type === 'ALL' ||
                    (type === 'Other' && $(obj).attr('class').indexOf('PDF') === -1 && $(obj).attr('class').indexOf('Video') === -1)
                    || $(obj).attr('class').indexOf(type) !== -1));
    };

    /* 
    * Check if the displayed text contains the typed in text. 
    */
    var objContainsText = function (obj) {
        if ($("[ID*=txtSearchVal]").val() === defaultSearchValue)
            return true; //No text to match. 
        else
            return $(obj).text().toLowerCase().indexOf($("[ID*=txtSearchVal]").val().toLowerCase()) !== -1;
    };


    ///Reveal up to the maximum display count of records into the isotope repeater.
    ///When there are more than 15 options, we hide the rest. 
    var manageRepeaterItemVisibility = function (type, tag, material) {
        var itemCount = 0;
        var isFirstItem = true;
        var numShown = 0;
        var retStr = "";

        $("[ID*=isotopeTraining]").each(function () {
            if (isMatch(this, type, tag, material)) {

                itemCount++;

                //Check if it's on the current page. Page counter uses 2 based core, and for first page we're looking between 2 and 9 
                if (itemCount >= pageStartIndex && itemCount < pageStartIndex + searchDisplayCount) {
                    if (retStr !== "") { retStr += ", "; }
                    //$(this).removeClass('no-transition');
                    retStr += "." + $(this).attr('class').substring($(this).attr('class').indexOf('isotopePagerIndex')).replace(' isotope-hidden', '');
                    numShown++;
                }

            }
        });

        //If we're not on the first page, and nothing is showing, revert to the first page, and re-try this function. 
        if (numShown === 0 && pageCounter !== 1) {
            pageCounter = 1;
            pageStartIndex = 1;
            return manageRepeaterItemVisibility(type, tag, material);
        }

        return retStr;
    };

    return {
        init: init
    };
})();